import { render, staticRenderFns } from "./biji.vue?vue&type=template&id=da246f92&scoped=true"
import script from "./biji.vue?vue&type=script&lang=js"
export * from "./biji.vue?vue&type=script&lang=js"
import style0 from "./biji.vue?vue&type=style&index=0&id=da246f92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da246f92",
  null
  
)

export default component.exports